"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItem = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
const ListItem = ({ isSectionLabel, selected, children, style, onClick, }) => {
    return (react_1.default.createElement(style_1.Wrapper, { "aria-label": "virtual list node", isSectionLabel: isSectionLabel, style: style, onClick: () => onClick && onClick(), onKeyPress: (e) => e.key === "Enter" && onClick && onClick() },
        react_1.default.createElement(style_1.SelectedBar, { selected: selected }),
        children));
};
exports.ListItem = ListItem;
//# sourceMappingURL=index.js.map